var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacyTip = function SvgPrivacyTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M450 772h60V515h-60zm30-323q14.45 0 24.225-9.775T514 415t-9.775-24.225T480 381t-24.225 9.775T446 415t9.775 24.225T480 449m0 526q-140-35-230-162.5T160 533V295l320-120 320 120v238q0 152-90 279.5T480 975m0-62q115-38 187.5-143.5T740 533V337l-260-98-260 98v196q0 131 72.5 236.5T480 913m0-337"
  })));
};
export default SvgPrivacyTip;